// Prism's pageless toolbar presets, named here so a host picks one without importing Prism.
export const PagelessToolbarPreset = Object.freeze({
  COMPACT: 'compact',
  EMAIL: 'email',
  SNIPPET: 'snippet',
});
